<template>
    <div class="error">
        <p>
            <img src="../assets/img/detail/error.svg" alt="" style="display: block; width: 50px; margin: 0 auto">
            <br>
            <span>error: path no found!</span>
        </p>
    </div>

</template>

<script>
  export default {
    name: "error"
  }
</script>

<style scoped>
    .error {
        margin: 0 auto;
        max-width: 640px;
        min-height: 100%;
        background: #fff;
    }

    p {
        margin: 0 auto;
        padding-top: 25vh;
        width: 235px;
        font-size: 20px;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/views/Error.vue